import React from 'react';
import ControlDialog from 'swag-client-common/components/info/control-dialog';
import SetPasswordForm from '../../partials/set-password-form';
import css from './set-password-popup.scss';
function SetPasswordPopup({
  onClose,
  requireApproveTerms
}) {
  return /*#__PURE__*/React.createElement(ControlDialog, {
    open: true,
    onRequestClose: onClose,
    showCloseButton: true,
    content: /*#__PURE__*/React.createElement(SetPasswordForm, {
      onClose: onClose,
      requireApproveTerms: requireApproveTerms
    })
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    dialogClass: css.popup
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    bodyClassName: css.bodyClassName
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    contentClassName: css.contentClassName
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    actionsContainerClassName: css.actionsContainerClassName
    // @todo. auto generated. fix this error
    // @ts-ignore
    ,
    paperClassName: css.paperClassName
  });
}
export default SetPasswordPopup;